import {VOUCHER_AND_COMPARATION} from "../../utils/constant";
import CardComparationComponent from "../../components/card-comparation.component";
import TabToggleComponent from "../../components/tab-toggle.component";
import React from "react";
import {useSelector} from "react-redux";
import {formatDateToReadable} from "../../utils/general-variable";
import {useFetch} from "../../services/useFetch";
import {API} from "../../services/api";
import {useEffectAfterMount} from "../../services/useEffectAfterMount";
import {LoadingSvg} from "../../utils/image";

const TabVoucherAndComparation = () => {
    const {dateRange, reload} = useSelector(state => state.toolsReducer)
    const queryParams = {
        startDate: formatDateToReadable(dateRange[0], "YYYY-MM-DD"),
        endDate: formatDateToReadable(dateRange[1], "YYYY-MM-DD")
    }
    const {
        data: response,
        fetching: getVoucherAndComparation,
        isLoading
    } = useFetch(API.ANALYTIC_VOUCHER_AND_COMPARISON, queryParams)

    useEffectAfterMount(() => {
        getVoucherAndComparation()
    }, [dateRange, reload])

    return (
        <TabToggleComponent
            title={'Voucher & Comparation'}
            content={
                isLoading ? <img src={LoadingSvg} className={"w-12 mx-auto"}/> :
                    <div className={"grid grid-cols-2 grid-flow-row gap-6"}>
                        {VOUCHER_AND_COMPARATION.map((list, index) => (
                            <div key={index} className={"col border border-orochimaru"}>
                                <CardComparationComponent cardList={list} data={response?.data ?? {}}/>
                            </div>
                        ))}
                    </div>
            }
        />
    )
}

export default TabVoucherAndComparation
